import React from "react";
import { Form, Input, Button, Typography, Alert } from "antd";
import { toast } from "react-toastify";
import { updateCard } from "../../api/AdminRequest";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

export default function UpdateSlug({ cardId, initialSlug }) {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const hasExistingSlug = initialSlug && initialSlug.trim() !== "";

  const handleSubmit = async (values) => {
    try {
      await updateCard(cardId, { slug: values.slug });

      toast.success("Slug updated successfully", {
        position: "top-right",
        autoClose: 3000,
        theme: "dark",
      });

      navigate("/all-cards");
    } catch (error) {
      toast.error(error.message || "Failed to update slug");
    }
  };

  const handleSlugChange = (e) => {
    const value = e.target.value
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "");

    form.setFieldsValue({ slug: value });
  };

  return (
    <>
      <Title level={4}>Update Slug</Title>

      {hasExistingSlug ? (
        <Alert
          type="warning"
          showIcon
          className="mb-4"
          message="Changing slug will break existing physical cards"
          description={
            <ul style={{ margin: "4px 0 0 0", paddingLeft: 18 }}>
              <li>
                Any <strong>printed cards, NFC tags, or QR codes</strong> using
                the old slug <code>{initialSlug}</code> will stop working.
              </li>
              <li>
                Only change this if you haven't distributed physical cards yet,
                or you are reprinting them.
              </li>
            </ul>
          }
        />
      ) : (
        <Alert
          type="info"
          showIcon
          className="mb-4"
          message="No slug set yet"
          description="This card currently has no slug. NFC and QR scanning redirects using the card ID instead. Setting a slug here will make the card accessible via the slug URL going forward."
        />
      )}

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ slug: initialSlug || "" }}
      >
        <Form.Item
          name="slug"
          label="Slug"
          rules={[
            { required: true, message: "Please enter slug" },
            {
              pattern: /^[a-z0-9-]+$/,
              message: "Only lowercase letters, numbers, and '-' allowed",
            },
          ]}
        >
          <Input
            size="large"
            placeholder="e.g. john-doe"
            onChange={handleSlugChange}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            className="bg-blue-600 hover:bg-blue-700"
            danger={hasExistingSlug}
          >
            {hasExistingSlug ? "Update Slug (Breaks Physical Cards)" : "Set Slug"}
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}